import { render, staticRenderFns } from "./UploadImageForm.vue?vue&type=template&id=01a4a300&scoped=true&"
import script from "./UploadImageForm.vue?vue&type=script&lang=js&"
export * from "./UploadImageForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageForm.vue?vue&type=style&index=0&id=01a4a300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4a300",
  null
  
)

export default component.exports